import React, { useState, useEffect } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import Header from "../components/Header";
import {
  AddProperty,
  ItemsGrid,
  ManageProperty,
  PropertiesCard,
  ActiveLeaseCard,
  MessagesModal,
  TenantSignLeaseModal,
  TransactionsModal,
  PaymentsModal,
  AlertBox,
  HeadMetaTags,
} from "../components";

import { BsHouseAdd } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const {
    modal,
    alert,
    handleAlert,
    setModal,
    handleModal,
    user,
    rooms,
    leases,
    balance,
    usersProperties,
    setUsersProperties,
    currentPropertyId,
    setCurrentPropertyId,
    recentlyViewedRoomsArray,
    handleSearchDropdown,
    checkPropertyAuth,
  } = useStateContext();

  const [recentlyViewedRooms, setRecentlyViewedRooms] = useState(
    recentlyViewedRoomsArray.reverse()
  );
  const [leaseToSign, setLeaseToSign] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (user.defaultView === "tenant" && localStorage.getItem("inviteId")) {
      const invitedLease = leases.find(
        (x) => x.uuid === localStorage.getItem("inviteId")
      );
      handleLeaseToSign(invitedLease);
    } else if (user.defaultView === "tenant") {
      const invitedLease = leases.find((x) => x.status === "created");
      handleLeaseToSign(invitedLease);
    }

    // let newArray = [];
    // for (const element of recentlyViewedRoomsArray) {
    //   newArray.push(publishedRooms.find((x) => x.roomId === element));
    // }
    // // setRecentlyViewedRooms(newArray.reverse());
  }, [rooms, recentlyViewedRoomsArray, user.defaultView]);

  const handleLeaseToSign = (lease) => {
    setLeaseToSign(lease);
    setModal({ ...modal, tenantSignLease: true });
  };

  const currentBalance = balance;

  return (
    <>
      <HeadMetaTags title="Dashboard | Roommates Made Simple" />
      {alert.propertyUpgrade && (
        <AlertBox
          handleAlert={handleAlert}
          alertType="propertyUpgrade"
          alertFunc={() => navigate("/account/subscription")}
        />
      )}
      {modal.addProperty && <AddProperty />}
      {modal.manageProperty && (
        <ManageProperty
          currentPropertyId={currentPropertyId}
          usersProperties={usersProperties}
          setUsersProperties={setUsersProperties}
        />
      )}
      {modal.messages && // can cause double rendering of message modal
        user.defaultView === "tenant" && (
          <MessagesModal
            senderId={leases[0].tenantId}
            recipientId={leases[0].landlordId}
          />
        )}
      {modal.tenantSignLease && leaseToSign && (
        <TenantSignLeaseModal lease={leaseToSign} />
      )}
      {modal.transactions && user.defaultView === "tenant" && (
        <TransactionsModal roomId={leases[0].roomId} />
      )}
      {modal.makePayment && user.defaultView === "tenant" && (
        <PaymentsModal balance={currentBalance} leaseId={leases[0].id} />
      )}
      <section id="header" className="w-screen">
        <Header />
      </section>
      <section
        id="dashboard-summary"
        className="mt-20 mb-20 overflow-y-auto overflow-hidden"
      >
        {user.defaultView === "landlord" && (
          <div className="grid justify-items-center mt-20">
            <div className="flex">
              <div
                id="add-property"
                name="addProperty"
                onClick={() => {
                  checkPropertyAuth()
                    ? handleModal("addProperty")
                    : handleAlert("propertyUpgrade");
                }}
              >
                <BsHouseAdd
                  className={`text-7xl text-blue-500 hover:text-blue-700 border-blue-500
           hover:border-blue-700 border-2 rounded-full mx-5 ${
             usersProperties.length ? "" : "animate-bounce"
           }`}
                />
              </div>
            </div>
            {usersProperties.length !== 0 ? (
              <>
                <div className="mt-10">
                  You have{" "}
                  <span className="text-snappily-orange">
                    {usersProperties.length}
                  </span>
                  {usersProperties.length >= 2 ? " properties" : " property"}
                </div>
                <PropertiesCard
                  properties={usersProperties}
                  handleModal={handleModal}
                  setCurrentPropertyId={setCurrentPropertyId}
                />
              </>
            ) : (
              <div className="mt-10 text-slate-400">
                You currently have no properties.
              </div>
            )}
          </div>
        )}
        {user.defaultView === "tenant" && (
          <>
            {leases[0] && leases[0].status === "active" && (
              <div className="mt-10">
                <div className="flex justify-start md:justify-center items-center text-2xl pl-5 md:pl-0">
                  <div>My Balance</div>
                </div>
                {/* move to seperate component */}
                <div className="grid justify-items-center">
                  <div className="w-80 border-2 border-gray-300 rounded-2xl mt-10 px-5 py-2">
                    <div className="flex justify-between">
                      <div className="text-2xl">Due:</div>
                      <div className="text-2xl">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(currentBalance)}
                      </div>
                    </div>
                    <div className="flex justify-end gap-x-5 mt-8">
                      <div
                        className="text-blue-500 hover:text-blue-700 cursor-pointer"
                        onClick={() => handleModal("transactions")}
                      >
                        Activity
                      </div>
                      <div
                        className={`${
                          currentBalance > 1 && leases[0].landlordStripeAccount
                            ? "text-blue-500 hover:text-blue-700 cursor-pointer"
                            : "text-gray-300"
                        }`}
                        onClick={
                          currentBalance > 1 && leases[0].landlordStripeAccount
                            ? () => handleModal("makePayment")
                            : () => {}
                        }
                      >
                        Make Payment
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* TODO: add support for multiple tenant leases? */}
            <div className="mt-10 overflow-y-auto overscroll-none">
              <div className="flex justify-start md:justify-center items-center text-2xl pl-5 md:pl-0">
                <div>My Lease</div>
              </div>
              <div className="flex justify-center mt-5">
                {leases[0] ? (
                  <ActiveLeaseCard
                    lease={leases[0]}
                    senderId={leases[0].tenantId}
                    recipientId={leases[0].landlordId}
                    tenantView={true}
                  />
                ) : (
                  <div className="text-slate-500">
                    You have no pending leases.
                  </div>
                )}
              </div>
            </div>
            <div className="mt-16">
              <div className="flex justify-start md:justify-center items-center text-2xl pl-5 md:pl-0">
                <div>Recently Viewed</div>
                {/* <div
                  className="text-xl text-blue-500 hover:text-blue-700 cursor-pointer pl-3"
                  onClick={() => navigate("/rooms")}
                >
                  (Browse Rooms)
                </div> */}
              </div>
              {recentlyViewedRooms.length === 0 ? (
                <div className="grid justify-items-center mt-5">
                  <div className="text-slate-500">
                    You have no recently viewed rooms.
                  </div>
                  <div
                    className="text-blue-500 hover:text-blue-700 mt-5 cursor-pointer"
                    onClick={() => handleSearchDropdown()}
                  >
                    Browse Rooms
                  </div>
                </div>
              ) : (
                <div className="mt-2">
                  <ItemsGrid roomsArray={recentlyViewedRooms} />
                </div>
              )}
            </div>
          </>
        )}
      </section>
    </>
  );
};

export default Dashboard;
